import { useState, useEffect } from 'react'
import _helpers from '@toasttab/shared/src/globals/_helpers'

// Note: This is a mock of the useGeoLocation hook that is used in the app.
export const useGeoLocation = () => {
  const [data, setData] = useState(null)
  const [isLoading, setisLoading] = useState(true)
  const [error, setError] = useState(null)
  const refetch: boolean = null

  useEffect(() => {
    const getGeoData = () => {
      const postalCode = _helpers.getCookie('_userPostalCode')
        ? _helpers.getCookie('_userPostalCode')
        : ''
      const countryCode = _helpers.getCookie('_userCountryCode')
        ? _helpers.getCookie('_userCountryCode')
        : ''
      const preferredRegion = _helpers.getCookie('_preferredRegion')
        ? _helpers.getCookie('_preferredRegion')
        : ''

      const geoDateJson = {
        postal: {
          code: postalCode
        },
        country: {
          iso_code: countryCode
        },
        regionPreference: {
          iso_code: preferredRegion
        }
      }

      setData(geoDateJson)
      setisLoading(false)
    }
    getGeoData()
  }, [])

  return {
    loading: isLoading,
    error: error,
    geoData: error ? null : data,
    refetch: refetch
  }
}
